import {
    checkPermission, getLocation, Permission, requestPermission,
} from '@utils/nativeUtils';
import { useEffect } from 'react';

import useNativeListener from './useNativeListener';

interface ILocation {
    lat: number,
    lon: number,
}

interface Props {
    deps?: any[];
    enabled?: boolean;
    callbackFn?: (data: ILocation) => void;
    /** 권한이 없을 때 권한 요청 팝업을 띄울지 여부. false 면 확인만 하고 끝낸다. */
    requestIfDenied?: boolean;
}

function useLocation({
    deps, enabled = true, callbackFn, requestIfDenied = true,
}:Props) {
    useNativeListener('getLocation', (result: ILocation) => {
        console.log('web: getLocation', result);
        callbackFn?.(result);
    });

    useNativeListener('checkPermission', (permission: Permission, hasPermission: boolean) => {
        console.log('web: check permission', { permission, hasPermission });
        if (permission === 'LOCATION' && hasPermission) {
            getLocation();
        } else if (permission === Permission.LOCATION && requestIfDenied) {
            requestPermission(Permission.LOCATION);
        }
    });

    useNativeListener('requestPermission', (permission: Permission, result: boolean) => {
        if (permission === Permission.LOCATION && result) {
            getLocation();
        }
    });

    useEffect(() => {
        if (enabled) {
            checkPermission(Permission.LOCATION);
        }
    }, [enabled, ...(deps || [])]);
}

export default useLocation;
